exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li:hover {\n  cursor: default; }\n\na:hover {\n  cursor: default; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/main/main-portal/faq/faq.component.scss
// module id = ../../../../../src/app/main/main-portal/faq/faq.component.scss
// module chunks = main